var e;
(function(t) {
  t[t.literal = 0] = "literal", t[t.argument = 1] = "argument", t[t.number = 2] = "number", t[t.date = 3] = "date", t[t.time = 4] = "time", t[t.select = 5] = "select", t[t.plural = 6] = "plural", t[t.pound = 7] = "pound", t[t.tag = 8] = "tag";
})(e || (e = {}));
var n;
(function(t) {
  t[t.number = 0] = "number", t[t.dateTime = 1] = "dateTime";
})(n || (n = {}));
function r(t) {
  return t.type === e.literal;
}
function u(t) {
  return t.type === e.argument;
}
function a(t) {
  return t.type === e.number;
}
function i(t) {
  return t.type === e.date;
}
function l(t) {
  return t.type === e.time;
}
function m(t) {
  return t.type === e.select;
}
function s(t) {
  return t.type === e.plural;
}
function o(t) {
  return t.type === e.pound;
}
function p(t) {
  return t.type === e.tag;
}
function c(t) {
  return !!(t && typeof t == "object" && t.type === n.number);
}
function f(t) {
  return !!(t && typeof t == "object" && t.type === n.dateTime);
}
export {
  n as SKELETON_TYPE,
  e as TYPE,
  u as isArgumentElement,
  i as isDateElement,
  f as isDateTimeSkeleton,
  r as isLiteralElement,
  a as isNumberElement,
  c as isNumberSkeleton,
  s as isPluralElement,
  o as isPoundElement,
  m as isSelectElement,
  p as isTagElement,
  l as isTimeElement
};
